import { render, staticRenderFns } from "./dedicated-info.vue?vue&type=template&id=10ed5138&scoped=true&"
import script from "./dedicated-info.vue?vue&type=script&lang=js&"
export * from "./dedicated-info.vue?vue&type=script&lang=js&"
import style0 from "./dedicated-info.vue?vue&type=style&index=0&id=10ed5138&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10ed5138",
  null
  
)

export default component.exports